import { mapValues } from 'lodash'
import { connect } from 'react-redux'
import Status from '@constants/request_statuses.ts'
import { getUsers } from '@selectors/data/user_selectors.js'
import { getComments } from '@selectors/data/comment_selectors.js'
import TimelineComments from '../components/TimelineComments.jsx'
import { fetchTimelineCommentsById } from '../actions/ClientActions.js'
import { selectLoadTimelineCommentsByIdStatus, selectLoadTimelineCommentsByIdError } from '../reducers/index.js'

const mapStateToProps = (state, props) => {
  const comments = getComments(state, props)
  const status = selectLoadTimelineCommentsByIdStatus(state, props) || Status.IDLE
  const error = selectLoadTimelineCommentsByIdError(state, props)

  const users = getUsers(state)
  const commentsData = mapValues(comments, comment => {
    const userIdString = comment.user.toString()
    const user = users[userIdString]
    return {
      ...comment,
      user,
    }
  })
  return {
    status,
    error,
    comments: commentsData,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onClickLoadComments: timelineId => {
      return dispatch(fetchTimelineCommentsById({ timelineId }))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TimelineComments)
